import ArrowDownIcon from './ArrowDownIcon'
import ArrowIcon from './ArrowIcon'
import ArrowLeftIcon from './ArrowLeftIcon'
import ArrowRightIcon from './ArrowRightIcon'
import ArrowUpIcon from './ArrowUpIcon'

export { ArrowDownIcon, ArrowIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon }
